import { ChangeEvent, useState } from 'react'
import { Noop, RefCallBack } from 'react-hook-form'

import InputFieldWithManagedState, {
  InputFieldWithManagedStateProps,
} from './with-managed-state'

interface InputChangeEvent {
  target: EventTarget & (HTMLInputElement | HTMLTextAreaElement)
  type?: string
}

type InputChangeHandler = (event: InputChangeEvent) => Promise<void | boolean>

type ChangeHandler = (event: ChangeEvent) => void

// Combination of ControllerRenderProps and ControllerRenderProps from react-hook-form
export interface CustomFormRegister {
  ref: RefCallBack
  name: string
  value?: string | number
  onChange: InputChangeHandler | ChangeHandler | Noop
  onBlur: InputChangeHandler | Noop
}

type InputFieldWithFormRegisterProps = Pick<
  InputFieldWithManagedStateProps,
  | 'type'
  | 'label'
  | 'isRequired'
  | 'placeholder'
  | 'max'
  | 'maxLength'
  | 'autoComplete'
  | 'errorMessage'
  | 'borderBottom'
  | 'isInvertedColors'
  | 'hasCustomInputStyles'
  | 'className'
  | 'labelClassName'
  | 'inputWrapperClassName'
  | 'inputClassName'
  | 'children'
> & {
  formRegister: CustomFormRegister
  defaultValue?: string
}

const InputFieldWithFormRegister = ({
  formRegister,
  defaultValue = '',
  type,
  label,
  isRequired,
  placeholder,
  max,
  maxLength,
  autoComplete,
  errorMessage,
  borderBottom,
  isInvertedColors,
  hasCustomInputStyles,
  className,
  labelClassName,
  inputWrapperClassName,
  inputClassName,
  children,
}: InputFieldWithFormRegisterProps) => {
  const [value, setValue] = useState(defaultValue)

  return (
    <InputFieldWithManagedState
      ref={formRegister.ref}
      type={type}
      name={formRegister.name}
      value={value}
      setValue={setValue}
      label={label}
      isRequired={isRequired}
      placeholder={placeholder}
      max={max}
      maxLength={maxLength}
      autoComplete={autoComplete}
      errorMessage={errorMessage}
      borderBottom={borderBottom}
      isInvertedColors={isInvertedColors}
      hasCustomInputStyles={hasCustomInputStyles}
      onChange={formRegister.onChange}
      onBlur={formRegister.onBlur}
      className={className}
      labelClassName={labelClassName}
      inputWrapperClassName={inputWrapperClassName}
      inputClassName={inputClassName}
    >
      {children}
    </InputFieldWithManagedState>
  )
}

export default InputFieldWithFormRegister
